import axios from 'axios'
import { returnErrors } from './errorActions'
import { jwtDecode } from 'jwt-decode'

import {
  LOADED_AUTHCONFIG,
  USER_LOADED,
  USER_LOADING,
  USER_PROFILE_UPDATED,
  AUTH_ERROR,
  LOGIN_UPDATING,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_UPDATING,
  LOGOUT_SUCCESS,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  CLEAR_ERRORS,
} from './types'

const baseurl = process.env.REACT_APP_SERVER_URL + '/api/auth/'
let fetching = false
let loading = false
export const authConfig = (req, cb) => (dispatch) => {
  if (fetching) return false
  fetching = true
  axios
    .get(baseurl)
    .then((res) => {
      fetching = false
      dispatch({
        type: LOADED_AUTHCONFIG,
        payload: typeof res.data != 'undefined' ? { ...res.data } : {},
      })
      if (cb) {
        cb(true)
      }
    })
    .catch((err) => {
      fetching = false
      if (err && err.response && typeof err.response.data != 'undefined') {
        if (cb) {
          cb(false)
        }
      }
    })
}

// Login User
export const login = (req, cb) => (dispatch, getState) => {
  const { email, password, remember, social_login } = req
  // Request body
  const body = JSON.stringify({ email, password, remember, social_login, source: 'web' })

  dispatch({ type: CLEAR_ERRORS })
  dispatch({ type: LOGIN_UPDATING })
  axios
    .post(baseurl, body, tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: typeof res.data != 'undefined' ? { ...res.data } : {},
      })
      if (cb) {
        cb(true, res.data.user)
      }
    })
    .catch((err) => {
      if (err && err.response && typeof err.response.data != 'undefined')
        dispatch(returnErrors(err.response.data.msg, err.response.status, 'LOGIN_FAIL', err.response.data.info))
      dispatch({ type: LOGIN_FAIL })
      if (cb) {
        cb(false, null)
      }
    })
}

// Register User
export const register = (req, cb) => (dispatch, getState) => {
  // Request body
  const body = JSON.stringify({ ...req, source: 'web' })

  axios
    .post(process.env.REACT_APP_SERVER_URL + '/api/users/register', body, tokenConfig(getState))
    .then((res) => {
      if (res.data.nextAction === 'verify-email') {
        if (cb) cb(res.data.msg, undefined, res.data.nextAction)
        return
      }
      // console.log(res.data)
      dispatch({
        type: REGISTER_SUCCESS,
        payload: typeof res.data != 'undefined' ? res.data : {},
      })
      if (cb) {
        cb(res.data.msg, res.data.user)
      }
    })
    .catch((err) => {
      // console.log(err)
      dispatch({ type: REGISTER_FAIL })
      if (err && err.response && typeof err.response.data != 'undefined') {
        dispatch(returnErrors(err.response.data.msg, err.response.status, 'REGISTER_FAIL'))
      }
      if (cb) {
        cb(false, err?.response?.data?.msg)
      }
    })
}

// Check token & load user
export const loadUser = (req, cb) => (dispatch, getState) => {
  const config = tokenConfig(getState)
  let { userTypeText } = req ? req : {}
  const token = window.localStorage.getItem('token')
  let noToken = false
  if (token) {
    let tokenDecoded = null
    try {
      tokenDecoded = jwtDecode(token)
    } catch (e) { }
    if (tokenDecoded) {
      if (!userTypeText && tokenDecoded.user_type_text) {
        userTypeText = tokenDecoded.user_type_text[0]
      }
      config.headers['x-auth-token'] = token
    } else noToken = true
  } else noToken = true
  // User loading
  dispatch({ type: USER_LOADING })
  if (noToken) {
    setTimeout(() => {
      dispatch({
        type: USER_LOADED,
        payload: { user: null },
      })
    }, 100)
    return
  }
  if (loading) return false
  loading = true

  axios
    .get(`${baseurl}user${userTypeText ? `?userTypeText=${userTypeText}` : ''}`, config)
    .then((res) => {
      loading = false
      if (userTypeText) {
        window.localStorage.setItem('profileType', userTypeText)
      }
      dispatch({
        type: USER_LOADED,
        payload: typeof res.data != 'undefined' ? { ...res.data } : {},
      })
      if (cb) {
        const switchUserType = jwtDecode(res.data.token).user_type_text[0]
        // console.log(res.data.user.user_type[0], switchUserType)
        cb(switchUserType)
      }
    })
    .catch((err) => {
      loading = false
      if (err && err.response && typeof err.response.data != 'undefined')
        dispatch(returnErrors(err.response.data.msg, err.response.status, 'AUTH_ERROR'))
      dispatch({ type: AUTH_ERROR })
      if (cb) cb()
    })
}

export const adminLoggedInAsUser = (adminToken, cb) => async (dispatch, getState) => {
  // await dispatch(logout('', () => {}));
  // Request body
  const body = JSON.stringify(adminToken)

  dispatch({ type: LOGIN_UPDATING })
  axios
    .post(baseurl + 'admin-login-as', body, tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: typeof res.data != 'undefined' ? { ...res.data } : {},
      })
      if (cb) cb(res.data)
    })
    .catch((err) => {
      if (err && err.response && typeof err.response.data != 'undefined') {
        dispatch(returnErrors(err.response.data.msg, err.response.status, 'LOGIN_FAIL'))
      }
      dispatch({ type: LOGIN_FAIL })
      if (cb) cb(null)
    })
}

// Logout User
export const logout = (req, cb) => (dispatch, getState) => {
  dispatch({ type: LOGOUT_UPDATING })
  axios
    .post(baseurl + 'logout', {}, tokenConfig(getState))
    .then(() => {
      window.localStorage.removeItem('session-exp-message')
      window.localStorage.removeItem('login-redirect-page')
      window.localStorage.removeItem('cartInfo')
      window.localStorage.removeItem('property_id')
      window.localStorage.removeItem('claimStatus')
      window.localStorage.removeItem('claimId')
      window.localStorage.removeItem('claimAddress')
      window.localStorage.removeItem('manualAddress')
      window.localStorage.removeItem('lastPaymentId')
      window.localStorage.removeItem('makePayment')
      window.localStorage.removeItem('payment_type')
      window.localStorage.removeItem('inviteClients')

      dispatch({ type: LOGOUT_SUCCESS })
      if (cb) cb()
    })
    .catch((err) => {
      if (err && err.response && typeof err.response.data != 'undefined')
        dispatch(returnErrors(err.response.data.msg, err.response.status, 'AUTH_ERROR'))
      dispatch({ type: AUTH_ERROR })
      if (cb) cb()
    })
}

export const updateUserProps = (req) => (dispatch) => {
  dispatch({
    type: USER_PROFILE_UPDATED,
    payload: { user: { ...req } },
  })
}

// Setup config/headers and token
export const tokenConfig = (getState) => {
  // Get token from localstorage
  const token = getState().auth.token

  // Headers
  const config = {
    headers: {
      'Content-type': 'application/json',
    },
  }

  // If token, add to headers
  if (token) {
    config.headers['x-auth-token'] = token
  }

  return config
}
